import { render } from "./AccessError.vue?vue&type=template&id=2273f3dd&scoped=true&ts=true"
import script from "./AccessError.vue?vue&type=script&lang=ts"
export * from "./AccessError.vue?vue&type=script&lang=ts"

import "./AccessError.vue?vue&type=style&index=0&id=2273f3dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2273f3dd"],['__file',"src/components/general/AccessError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2273f3dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2273f3dd', __exports__)) {
    api.reload('2273f3dd', __exports__)
  }
  
  module.hot.accept("./AccessError.vue?vue&type=template&id=2273f3dd&scoped=true&ts=true", () => {
    api.rerender('2273f3dd', render)
  })

}


export default __exports__